import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import WeddingIntro from "../components/WeddingIntro";
import GuestForm from "../components/GuestForm";
import DayDetails from "../components/DayDetails";
import ContactInfo from "../components/ContactInfo";
import HeroCarouselSection from "../components/HeroCarouselSection";

const GuestPage = () => {
  const location = useLocation();

  useEffect(() => {
    
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  return (
    <section className="min-h-screen">  
      <Navbar />
      <div id="hero" className="py-10">
        <HeroCarouselSection />
      </div>
      <div className="max-w-7xl mx-auto">
        <div
          id="intro"
          className="relative w-full md:w-1/2 mx-auto px-6 py-10 after:content-[''] after:block after:w-48 after:h-[1px] after:bg-royal-gold-300 after:mx-auto after:mt-16 after:mb-2"
        >
          <WeddingIntro />
        </div>
        <div
          id="form"
          className="relative w-full md:w-1/2 mx-auto px-6 py-10 after:content-[''] after:block after:w-48 after:h-[1px] after:bg-royal-gold-300 after:mx-auto after:mt-16 after:mb-2"
        >
          <GuestForm />
        </div>
        <div 
          id="details" 
          className="relative w-full md:w-1/2 mx-auto px-6 py-10 after:content-[''] after:block after:w-48 after:h-[1px] after:bg-royal-gold-300 after:mx-auto after:mt-16 after:mb-2"
        >
          <DayDetails />
        </div>
        <div id="contact" className="py-10">
          <ContactInfo />
        </div>
      </div>
    </section>
  );
};

export default GuestPage;
